import { CircularProgress, Grid, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import AuthRequestStatus from '../../enums/AuthRequestStatus';
import { useAppSelector } from '../../store/hooks';
import LoginRegisterContainer from '../Shared/LoginRegister/LoginRegisterContainer';
import { OfferForm } from './OfferForm';

export function OfferAuth() {
    const { classes } = useStyles();
    const history = useHistory();
    const location = useLocation();

    const appState = useAppSelector(state => {
        return {
            authRequestStatus: state.user.authStatus.requestStatus,
            firstName: state.user.userFirstName,
        };
    });

    const cancel = useMemo(() => {
        const query = new URLSearchParams(location.search);
        return query.get('cancelled');
    }, [location.search]);

    const handleContinueToSic = () => {
        history.push('/');
    };

    if (appState.authRequestStatus === AuthRequestStatus.active) {
        return (
            <Grid container item justifyContent="center" alignContent="center" xs={12} md={6} p={4}>
                <CircularProgress />
            </Grid>
        );
    }

    return (
        <Grid container item xs={12} md={6} justifyContent="center" spacing={4} p={4}>
            {appState.authRequestStatus === AuthRequestStatus.configSuccess && (
                <>
                    <Grid container flexDirection="column" spacing={2} item justifyContent="center">
                        <Grid item>
                            <Typography variant="h5" textAlign="center">
                                Welcome, {appState.firstName}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container item>
                        <OfferForm />
                    </Grid>
                    {cancel === 'true' && (
                        <Grid container item justifyContent="center">
                            <Typography variant="subtitle2" className={classes.warningText}>
                                Your payment has been cancelled
                            </Typography>
                        </Grid>
                    )}
                    <Grid container alignContent="center" justifyContent="center"></Grid>
                    {/* 
                        Requested to be removed
                    <Grid container item flexDirection="row" spacing={2} justifyContent="center">
                        <Grid item>
                            <Button variant="text" color="primary" onClick={handleContinueToSic}>
                                Dashboard
                            </Button>
                        </Grid>
                        <Grid item>
                            <ButtonLogout variant="text" />
                        </Grid>
                    </Grid> */}
                </>
            )}
            {appState.authRequestStatus !== AuthRequestStatus.configSuccess && (
                <LoginRegisterContainer />
            )}
        </Grid>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    warningText: {
        color: theme.palette.error.main,
    },
}));
